var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Affix',[_c('div',{staticClass:"topBox"},[_c('div',{staticClass:"topBox_text"},[_c('div',[_vm._v("996传奇盒子")]),_c('div',[_vm._v("三端互通 千款版本")])]),_c('div',{staticClass:"topBox_btn",on:{"click":_vm.downloads}},[_vm._v("立即下载")])])])}
var staticRenderFns = []

export { render, staticRenderFns }